import { shallow, useOthersMapped } from "@liveblocks/react";
import type { User } from "../types";

export const useGetUserOnSlide = (slideId: string): User | null => {
  const users = useOthersMapped(
    (other) => ({
      activeSlideId: other.presence.activeSlideId,
      info: other.info as User,
    }),
    shallow,
  );
  const user = users.find(
    ([_, { activeSlideId }]) => activeSlideId === slideId,
  );
  if (!user) return null;
  return user[1].info as User;
};
